import Footer from '@/components/footer'
import Header from '@/components/header'
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@/components/ui/accordion'
import { MinusIcon } from '@heroicons/react/20/solid'
import { PlusIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'

export const Faqs = () => {
	return (
		<div className="bg-landing-page bg-cover bg-no-repeat">
			<div className="max-w-[150rem] mx-auto">
				<Header currentPage="faqs" />
				<div className="mt-5 lg:mt-[90px] flex items-center flex-col gap-3 lg:gap-2">
					<h1 className="text-secondary text-center text-xl lg:text-5xl font-extrabold">
						Frequently asked questions
					</h1>
					<p className="text-secondary text-center text-sm lg:text-xl font-medium">
						Schnelle Hilfe bei Ihren Fragen
					</p>
				</div>
				<div className="max-w-5xl mx-auto">
					<Accordion
						type="multiple"
						className="max-lg:mx-5 space-y-5 lg:space-y-8 lg:w-full mt-8 lg:mt-[90px]">
						<AccordionItem
							className="p-4 lg:p-8 rounded-xl lg:rounded-3xl bg-[#F8F9F6]"
							value="item-1">
							<AccordionTrigger
								openIcon={MinusIcon}
								closeIcon={PlusIcon}
								className="text-secondary py-0 data-[state=open]:pb-2 lg:data-[state=open]:pb-4 text-xs lg:text-xl font-extrabold">
								Wie kann ich bei euch ein Regal buchen?
							</AccordionTrigger>
							<AccordionContent className="text-muted-foreground max-lg:text-[10px] pb-0 font-medium leading-5 lg:leading-[34px]">
								Der Buchungsprozess erfolgt über unsere Homepage über den Reiter Regal mieten.
							</AccordionContent>
						</AccordionItem>
						<AccordionItem
							className="p-4 lg:p-8 rounded-xl lg:rounded-3xl bg-[#F8F9F6]"
							value="item-2">
							<AccordionTrigger
								openIcon={MinusIcon}
								closeIcon={PlusIcon}
								className="text-secondary py-0 data-[state=open]:pb-2 lg:data-[state=open]:pb-4 text-xs lg:text-xl font-extrabold">
								Wann kann ich mein gemietetes Regal füllen und wann muss es wieder geräumt sein?
							</AccordionTrigger>
							<AccordionContent className="text-muted-foreground max-lg:text-[10px] pb-0 font-medium leading-5 lg:leading-[34px]">
								Du kannst dein Regal frühestens einen Werktag vor Mietbeginn, eine Stunde vor
								Ladenschluss, füllen. Ab Mietbeginn ganztägig während der Öffnungszeiten auffüllen.
								Das Regal muss eine Stunde vor Ladenschluss, am Tag des Mietendes, ausgeräumt sein.
							</AccordionContent>
						</AccordionItem>
						<AccordionItem
							className="p-4 lg:p-8 rounded-xl lg:rounded-3xl bg-[#F8F9F6]"
							value="item-3">
							<AccordionTrigger
								openIcon={MinusIcon}
								closeIcon={PlusIcon}
								className="text-secondary py-0 data-[state=open]:pb-2 lg:data-[state=open]:pb-4 text-xs lg:text-xl font-extrabold">
								Wer hält meinen Stand während meiner Mietlaufzeit ordentlich?
							</AccordionTrigger>
							<AccordionContent className="text-muted-foreground max-lg:text-[10px] pb-0 font-medium leading-5 lg:leading-[34px]">
								Wir sorgen täglich für eine grundlegende Ordnung im Laden, wie beispielsweise das
								Vermeiden von Kleidungsstücken auf dem Boden. Jeder Mieter ist jedoch selbst dafür
								verantwortlich, die Ordnung und Präsentation seiner Waren im Regal
								aufrechtzuerhalten.
							</AccordionContent>
						</AccordionItem>
						<AccordionItem
							className="p-4 lg:p-8 rounded-xl lg:rounded-3xl bg-[#F8F9F6]"
							value="item-4">
							<AccordionTrigger
								openIcon={MinusIcon}
								closeIcon={PlusIcon}
								className="text-secondary py-0 data-[state=open]:pb-2 lg:data-[state=open]:pb-4 text-xs lg:text-xl font-extrabold">
								Was darf ich nicht zum Verkauf anbieten?
							</AccordionTrigger>
							<AccordionContent className="text-muted-foreground max-lg:text-[10px] pb-0 font-medium leading-5 lg:leading-[34px]">
								Beschädigte, nicht funktionierende oder stark verschmutzte Kleidungsstücke dürfen
								nicht zum Verkauf angeboten werden. Ebenfalls bitten wir darum, keine gefälschten
								Produkte anzubieten. Wenn du unsicher bist, frage gerne bei uns nach.
							</AccordionContent>
						</AccordionItem>
						<AccordionItem
							className="p-4 lg:p-8 rounded-xl lg:rounded-3xl bg-[#F8F9F6]"
							value="item-5">
							<AccordionTrigger
								openIcon={MinusIcon}
								closeIcon={PlusIcon}
								className="text-secondary py-0 data-[state=open]:pb-2 lg:data-[state=open]:pb-4 text-xs lg:text-xl font-extrabold">
								Gibt es eine maximale Anzahl an Artikeln, die ich in meinem Regal verkaufen darf?
							</AccordionTrigger>
							<AccordionContent className="text-muted-foreground max-lg:text-[10px] pb-0 font-medium leading-5 lg:leading-[34px]">
								Wir schreiben keine begrenzte Anzahl von Artikeln vor, empfehlen jedoch, das Regal
								nicht übermäßig voll zu machen. Volle Regale wirken oft unübersichtlich und
								unordentlich, was potenzielle Käufer abschrecken könnte.
							</AccordionContent>
						</AccordionItem>
						<AccordionItem
							className="p-4 lg:p-8 rounded-xl lg:rounded-3xl bg-[#F8F9F6]"
							value="item-6">
							<AccordionTrigger
								openIcon={MinusIcon}
								closeIcon={PlusIcon}
								className="text-secondary py-0 data-[state=open]:pb-2 lg:data-[state=open]:pb-4 text-xs lg:text-xl font-extrabold">
								Kann ich mein Regal während meiner Mietlaufzeit mit weiteren Artikeln auffüllen?
							</AccordionTrigger>
							<AccordionContent className="text-muted-foreground max-lg:text-[10px] pb-0 font-medium leading-5 lg:leading-[34px]">
								Du kannst beliebig oft Artikel austauschen, neu auffüllen oder aus dem Regal
								entfernen. Bitte gib uns an der Kasse Bescheid, wenn du Artikel wieder mit nach
								Hause nimmst. Vergiss nicht neue Artikel auf der Homepage einzutragen, damit du
								weitere Preisetiketten von uns erhältst.
							</AccordionContent>
						</AccordionItem>
						<AccordionItem
							className="p-4 lg:p-8 rounded-xl lg:rounded-3xl bg-[#F8F9F6]"
							value="item-7">
							<AccordionTrigger
								openIcon={MinusIcon}
								closeIcon={PlusIcon}
								className="text-secondary py-0 data-[state=open]:pb-2 lg:data-[state=open]:pb-4 text-xs lg:text-xl font-extrabold">
								Was passiert, wenn ich es nicht schaffe mein Regal rechtzeitig bei Mietende zu
								räumen?
							</AccordionTrigger>
							<AccordionContent className="text-muted-foreground max-lg:text-[10px] pb-0 font-medium leading-5 lg:leading-[34px]">
								Wir verstehen, dass immer etwas Unvorhergesehenes passieren kann. Bitte informiere
								uns rechtzeitig und wir finden eine Lösung. Sollten wir keine Benachrichtigung
								erhalten und das Regal eine Stunde vor Feierabend am letzten Miettag immer noch
								nicht geräumt sein, berechnen wir 15,- € für das Leerräumen sowie fünf Euro pro Tag
								für die Lagerung.
							</AccordionContent>
						</AccordionItem>
						<AccordionItem
							className="p-4 lg:p-8 rounded-xl lg:rounded-3xl bg-[#F8F9F6]"
							value="item-8">
							<AccordionTrigger
								openIcon={MinusIcon}
								closeIcon={PlusIcon}
								className="text-secondary py-0 data-[state=open]:pb-2 lg:data-[state=open]:pb-4 text-xs lg:text-xl font-extrabold">
								Kann ich auch meinen Kinderwagen, Autositz, etc. bei euch verkaufen?
							</AccordionTrigger>
							<AccordionContent className="text-muted-foreground max-lg:text-[10px] pb-0 font-medium leading-5 lg:leading-[34px]">
								Auf Anfrage kannst du auch größere Gegenstände bei uns verkaufen. Wenn du ein Regal
								bei uns gemietet hast, ist dies im Mietpreis enthalten. Wenn du kein Regal bei uns
								hast, berechnen wir eine Provision i.H.v 25 % des Verkaufspreises.
							</AccordionContent>
						</AccordionItem>
						<AccordionItem
							className="p-4 lg:p-8 rounded-xl lg:rounded-3xl bg-[#F8F9F6]"
							value="item-9">
							<AccordionTrigger
								openIcon={MinusIcon}
								closeIcon={PlusIcon}
								className="text-secondary py-0 data-[state=open]:pb-2 lg:data-[state=open]:pb-4 text-xs lg:text-xl font-extrabold">
								Ich möchte selbstgemachte Dinge verkaufen. Kann ich dafür ein Regal bei euch mieten?
							</AccordionTrigger>
							<AccordionContent className="text-muted-foreground max-lg:text-[10px] pb-0 font-medium leading-5 lg:leading-[34px]">
								Du kannst auch selbstgemachte Dinge bei uns verkaufen. Bedenke jedoch, dass dies als
								gewerbliche Tätigkeit gilt und versteuert werden muss. Wir übernehmen keine Beratung
								oder Haftung in diesem Zusammenhang.
							</AccordionContent>
						</AccordionItem>
						<AccordionItem
							className="p-4 lg:p-8 rounded-xl lg:rounded-3xl bg-[#F8F9F6]"
							value="item-10">
							<AccordionTrigger
								openIcon={MinusIcon}
								closeIcon={PlusIcon}
								className="text-secondary py-0 data-[state=open]:pb-2 lg:data-[state=open]:pb-4 text-xs lg:text-xl font-extrabold">
								Wie erhalte ich die Auszahlung meines Verkaufsumsatzes?
							</AccordionTrigger>
							<AccordionContent className="text-muted-foreground max-lg:text-[10px] pb-0 font-medium leading-5 lg:leading-[34px]">
								Am Ende deiner Mietlaufzeit erhältst du eine Rechnung, auf der dein gesamter
								Verkaufsumsatz sowie die zu zahlende Provision ausgewiesen sind. Die Differenz wird
								dir per Überweisung gutgeschrieben. Nachdem du dein Regal ausgeräumt hast dauert es
								7 Werktage bis deine Abrechnung erstellt wird.
							</AccordionContent>
						</AccordionItem>
					</Accordion>
				</div>
				<Link
					to="/letter"
					className="mt-16 block font-extrabold text-secondary underline text-sm leading-6 lg:leading-8 lg:text-xl text-center">
					Alle weiteren Informationen findest Du in unseren Allgemeinen Geschäftsbedingungen.
				</Link>
			</div>
			<div className="mt-16 lg:mt-[141px] bg-[#E6E6E6] w-full h-px" />
			<Footer />
		</div>
	)
}
